import React, { Component } from "react";
import Helmet from "react-helmet";
import { Layout, Menu } from "antd";
const { Sider, Content } = Layout;
import PatentToolbar from "./toolbar/toolbar";
import { withRouter } from "react-router";
import { omitBy, isEmpty } from "lodash";
import { keepOnlyPatentSearchQueryStrings, mapPatentSearchQueryStringToName } from "../../helpers/url";
import { toSplittedNumbers } from "../../helpers/converters";
import { withUser } from "@unifiedpatents/sso";
import AppliedFilters from "../common/applied-filters";
import CallToLogin from "../common/call-to-login";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  verticalGutter: {
    marginTop: 16
  }
};

class PatentSearch extends Component {
  state = {
    activeSampleTab: "analytics"
  };

  componentDidMount() {
    this.props.router.push({
      pathname: this.props.location.pathname,
      query: isEmpty(this.props.location.query) ? { publication_type: "G", publication_status: "Active" } : this.props.location.query
    });
  }

  render() {
    const helmet = {
      title: "Search",
      meta: [
        {
          name: "keywords",
          content: "Search,Patent, Patent Filters, Patent Quality,Patent Validity,Citation,Rating, Broadness, Patent Broadness"
        },
        {
          name: "description",
          content: "AI-powered patents research and analytics."
        }
      ]
    };

    const {
      status: { isLoggedIn, canAccessData },
      metadata
    } = this.props.user;
    const accessLevel = canAccessData && metadata.authorization.roles.indexOf("disallow-patent-export") < 0 ? "full" : isLoggedIn ? "guest" : "public";
    const filter = this._getFilter();
    const defaultQuery = { publication_type: "G", publication_status: "Active" };
    return (
      <div style={styles.body}>
        <Helmet {...helmet} />
        <Layout>
          <Sider width={260} breakpoint="lg" collapsedWidth="0" style={{ background: "transparent", marginRight: 16 }}>
            <PatentToolbar filter={filter} accessLevel={accessLevel} />
          </Sider>
          <Content>
            <AppliedFilters fieldSelector={keepOnlyPatentSearchQueryStrings} fieldMapper={mapPatentSearchQueryStringToName} defaultQuery={defaultQuery} />
            {accessLevel === "public" ? <CallToLogin text="Please log in to access all pages." style={{ margin: 8 }} /> : null}
            <Menu selectedKeys={[this.props.location.pathname]} onClick={this._onMenuClick} mode="horizontal" style={styles.verticalGutter}>
              <Menu.Item key="/patents/search">{"PATENT LIST"}</Menu.Item>
              <Menu.SubMenu title="ANALYTICS" key="/patents/analytics">
                <Menu.Item key="/patents/analytics/top-assignees">{"Top Assignees"}</Menu.Item>
                <Menu.Item key="/patents/analytics/top-law-firms">{"Top Law Firms"}</Menu.Item>
                <Menu.Item key="/patents/analytics/ptab-and-litigation">{"PTAB and Litigation"}</Menu.Item>
                <Menu.Item key="/patents/analytics/by-date">{"By Date"}</Menu.Item>
                <Menu.Item key="/patents/analytics/opposition">{"Opposition"}</Menu.Item>
              </Menu.SubMenu>
            </Menu>
            {React.cloneElement(this.props.children, {
              key: this.props.location.pathname + this.props.location.search,
              filter,
              accessLevel
            })}
          </Content>
        </Layout>
      </div>
    );
  }

  _getFilter = () => {
    const query = keepOnlyPatentSearchQueryStrings(this.props.location.query);
    return {
      ...omitBy(
        {
          ucid_spif: toSplittedNumbers(query.ucid_spif),
          assignee_parent: query.assignee_parent,
          assignee_current: query.assignee_current,
          assignee_original: query.assignee_original,
          inventors: query.inventors,
          priority_date: query.priority_date,
          publication_date: query.publication_date,
          application_date: query.application_date,
          expiration_date: query.expiration_date,
          rating_broadness: query.rating_broadness,
          rating_citation: query.rating_citation,
          rating_litigation: query.rating_litigation,
          portfolio_score: query.portfolio_score ? query.portfolio_score.split("--")[0] + "--" + (parseInt(query.portfolio_score.split("--")[1]) + 1) : query.portfolio_score,
          rnix_score: query.rnix_score ? query.rnix_score.split("--")[0] + "--" + (parseInt(query.rnix_score.split("--")[1]) + 1) : query.rnix_score,
          family_id: toSplittedNumbers(query.family_id),
          extended_family_id: toSplittedNumbers(query.extended_family_id),
          cpc_codes: query.cpc_codes,
          uspc_codes: query.uspc_codes,
          country: query.country,
          doc_category: query.doc_category,
          transaction_type: query.transaction_type,
          publication_type: query.publication_type,
          publication_status: query.publication_status,
          opposition_country: query.opposition_country,
          full_text: query.full_text,
          full_text_fields: query.full_text_fields,
          is_litigated: query.is_litigated,
          is_challenged: query.is_challenged
        },
        isEmpty
      )
    };
  };

  _onMenuClick = item => {
    this.props.router.push({
      pathname: item.key,
      query: keepOnlyPatentSearchQueryStrings(this.props.location.query)
    });
  };
}

export default withUser(withRouter(PatentSearch));
